export enum DashboardWidget {
    TotalDescents="total",
    UniqueDescents="unique",
    RecentDescents="recent"
} 